import axios from "axios";

const LoginApi = axios.create({
    // baseURL: 'http://cblinfo.com.br:8000/'
		baseURL: 'https://cblinfo.automafour.com.br/'
});

export default LoginApi;